export enum PatientPauseStatusValueType {
  PAUSED = 'PAUSED',
  ONGOING = 'ONGOING',
}
